/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */


const timelineOuterWrapper = document.querySelector(".timeline-events-outer-wrapper");
const timelineInnerWrapper = document.querySelector(".timeline-events-inner-wrapper");
const timelineNav = document.querySelector(".timeline-navigation");
const timelineWrapper = document.querySelector(".wp-block-so-timeline-so-timeline");

let clicking = false;
let clickingNav = false;
let currentYear = timelineInnerWrapper.firstChild;

const navScrollBar = timelineNav.querySelector(".nav-scrollbar");

let navScrollBarWidth = navScrollBar.offsetWidth;
let navTrackScrollWidth = timelineInnerWrapper.offsetWidth - timelineOuterWrapper.offsetWidth;

function updateSize() {
    navScrollBarWidth = navScrollBar.offsetWidth;
    navTrackScrollWidth = timelineInnerWrapper.offsetWidth - timelineOuterWrapper.offsetWidth;
}

window.addEventListener("resize", event => {
    updateSize();
});



document.addEventListener("DOMContentLoaded", function (event) {

    updateSize();

    //make timeline draggable
    timelineInnerWrapper.addEventListener("mousedown", event => {
        clicking = true;
    });

    document.addEventListener("mouseup", event => {
        clickingNav = false;
        clicking = false;

    });

    timelineInnerWrapper.addEventListener("mousemove", event => {
        if (clicking) {
            timelineOuterWrapper.scrollLeft = timelineOuterWrapper.scrollLeft - event.movementX;
        }
    });

    const centurySelectors = timelineWrapper.querySelectorAll('.century-selector-wrapper ul button');

    //current focused event 
    document.querySelectorAll('.timeline-event').forEach((i) => {
        if (i) {
            const observer = new IntersectionObserver((entries) => {
                observerCallback(entries, observer, i)
            },
                {
                    threshold: 0,
                    rootMargin: "0% -80% 0% -20%",
                    root: timelineWrapper
                });
            observer.observe(i);
        }
    })

    const observerCallback = (entries, observer, header) => {
        entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
                currentYear = entry.target;

                centurySelectors.forEach((centurySelector) => {
                    centurySelector.classList.remove('current');
                    if (centurySelector.dataset.century === entry.target.dataset.century) {
                        centurySelector.classList.add('current');
                    }
                })
            }
        });
    };

    //navigation

    const nextButton = timelineNav.querySelector(".next");
    nextButton.addEventListener("click", event => {
        nextYear = currentYear.nextSibling;

        if (nextYear) {
            timelineOuterWrapper.scrollTo({
                left: nextYear.offsetLeft,
                behavior: "smooth"
            });
        }
    });

    const prevButton = timelineNav.querySelector(".prev");
    prevButton.addEventListener("click", event => {
        prevYear = currentYear.previousSibling;

        if (prevYear) {
            timelineOuterWrapper.scrollTo({
                left: prevYear.offsetLeft,
                behavior: "smooth"
            });
        }
    });


    // move bottom scrollbar when scrolling timeline
    const navCursor = timelineNav.querySelector(".nav-scrollbar-cursor");

    let navTrackScrollProgress = 0;

    timelineOuterWrapper.addEventListener('scroll', event => {

        if (!clickingNav) {
            navTrackScrollProgress = event.target.scrollLeft / navTrackScrollWidth;
            const navTrackScrollProgressPx = (navTrackScrollProgress * navScrollBarWidth);
            navCursor.style.left = `${navTrackScrollProgressPx}px`;
        }
    });


    //scroll timeline when dragging bottom scrollbar:

    navCursor.addEventListener("mousedown", event => {
        clickingNav = true;
    });

    timelineWrapper.addEventListener("mousemove", event => {
        if (clickingNav) {

            const newPositionNavCursor = navCursor.offsetLeft + event.movementX;

            if (newPositionNavCursor >= 0 && newPositionNavCursor <= navScrollBar.offsetWidth) {

                //drag scrollbar 
                navCursor.style.left = `${newPositionNavCursor}px`;

                //scroll timeline

                const navBarPercentage = newPositionNavCursor / navScrollBar.offsetWidth;
                const newTimelinePosition = navBarPercentage * navTrackScrollWidth;
                timelineOuterWrapper.scrollLeft = newTimelinePosition;

            }
        }
    });

    //centuries navigation

    const button1800 = timelineWrapper.querySelector('.selector-1800');
    const button1900 = timelineWrapper.querySelector('.selector-1900');
    const button2000 = timelineWrapper.querySelector('.selector-2000');

    const firstEvent1800 = timelineWrapper.querySelector('.event-1899');
    const firstEvent1900 = timelineWrapper.querySelector('.event-1907');
    const firstEvent2000 = timelineWrapper.querySelector('.event-2009');

    button1800.addEventListener("click", event => {
        timelineOuterWrapper.scrollTo({
            left: firstEvent1800.offsetLeft,
            behavior: "smooth"
        });
    });

    button1900.addEventListener("click", event => {
        timelineOuterWrapper.scrollTo({
            left: firstEvent1900.offsetLeft,
            behavior: "smooth"
        });
    });

    button2000.addEventListener("click", event => {
        timelineOuterWrapper.scrollTo({
            left: firstEvent2000.offsetLeft,
            behavior: "smooth"
        });
    });


});

window.addEventListener("load", () => {
    updateSize();
})
/* eslint-enable no-console */
